<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:widgets>
      <v-row class="rowSmall">
        <v-col cols="auto">
          <card-view title="Сумма оказанных услуг" :loading="loadState.isLoading" min-height="84">
            <template v-slot:content>
              <v-progress-circular
                v-if="loadState.isLoading"
                class="justify-center"
                indeterminate
                color="primary"
              ></v-progress-circular> 
              <h2 v-else class="font-weight-medium mb-2">{{$tools.price(collectFields.providedSum)}}</h2>
            </template>
          </card-view>
        </v-col>
        <v-col cols="auto" v-if="collectFields.usersProvidedSum != undefined">
          <card-view title="Сумма оказанных услуг (с учётом составных)" :loading="loadState.isLoading" min-height="84" tooltip="В итоговую стоимость включается только та часть составной услуги, которая фактически была оказана специалистом.">
            <template v-slot:content>
              <v-progress-circular
                v-if="loadState.isLoading"
                class="justify-center"
                indeterminate
                color="primary"
              ></v-progress-circular> 
              <h2 v-else class="font-weight-medium mb-2">{{$tools.price(collectFields.usersProvidedSum)}}</h2>
            </template>
          </card-view>
        </v-col>
        <v-col cols="auto">
          <card-view title="Сумма оплаченных услуг" :loading="loadState.isLoading" min-height="84">
            <template v-slot:content>
              <v-progress-circular
                v-if="loadState.isLoading"
                class="justify-center"
                indeterminate
                color="primary"
              ></v-progress-circular> 
              <h2 v-else class="font-weight-medium mb-2">{{$tools.price(collectFields.paidSum)}}</h2>
            </template>
          </card-view>
        </v-col>
        <v-col cols="auto">
          <card-view title="Сумма неоплаченных услуг" :loading="loadState.isLoading" min-height="84">
            <template v-slot:content>
              <v-progress-circular
                v-if="loadState.isLoading"
                class="justify-center"
                indeterminate
                color="primary"
              ></v-progress-circular> 
              <h2 v-else class="font-weight-medium mb-2">{{$tools.price(collectFields.unpaidSum)}}</h2>
            </template>
          </card-view>
        </v-col>
      </v-row>
    </template>
    <template v-slot:nav>
       <div class="px-4">

        <date-interval name="Интервал" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo" />

        <text-field name="Наименование услуги" :value.sync="filter.serviceName"/>

        <services-select :selectedServices.sync="filter.selectedServices"/>

        <text-field name="id услуги в визите" :value.sync="filter.visitServiceId"/>

        <text-field name="id Визита" :value.sync="filter.visitId"/>
        
        <v-row class="rowSmall mb-2">
          <v-col>
            <text-field class="mb-0" name="Цена от" :value.sync="filter.priceFrom" after-icon="mdi-currency-rub" format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="1000 или 1000.10"/>
          </v-col>
          <v-col>
            <text-field class="mb-0" name="Цена до" :value.sync="filter.priceTo" after-icon="mdi-currency-rub" format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="1000 или 1000.10"/>
          </v-col>
        </v-row>

        <autocomplete-multiple name="Статус оплаты" :items="payStatuses" :select.sync="filter.payStatus" textOverflow/>

        <com-branch-autocomplete-multiple :select.sync="filter.comBranchsSelected" globalState/>

        <direction-autocomplete-multiple :select.sync="filter.directionsSelected"/>

        <checkbox-field name="Без направления" class="mb-4" :value.sync="filter.emptyDirections"/>

        <checkbox-field name="Услуги по ОМС" class="mb-4" :value.sync="filter.oms"/>

        <checkbox-field name="Услуги по ДМС" class="mb-4" :value.sync="filter.dms"/>

        <insur-select @selected="(i)=>filter.insurSelected = i" class="mb-4" selectAllEnabled/>

        <spec-autocomplete-multiple  :select.sync="filter.specsSelected" />

        <user-autocomplete-multiple name="Клиенты" :select.sync="filter.userClientSelected"/>
        <user-autocomplete-multiple name="Специалисты" _type="spec" :select.sync="filter.userSpecSelected"/>
        <user-autocomplete-multiple name="Администраторы" _type="admin" :select.sync="filter.userAdminSelected"/>

        <referral-autocomplete-multiple name="Направляющий" :select.sync="filter.referrerSelected" />

        <date-interval name="Дата рождения" :valueFrom.sync="filter.userBirthFrom" :valueTo.sync="filter.userBirthTo" />
        <autocomplete-multiple name="Пол клиента" :items="genders" :select.sync="filter.userGender" textOverflow/>  

      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
          ref="table"
          name="Список"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          class=""
          :headers="[
            { text: 'ID', value: 'id', align: 'start', class:'text-no-wrap', sortable: true},
            { text: 'ID в реестре', value: 'id', align: 'start', class:'text-no-wrap', sortable: true},
            { text: 'Дата', value: 'visit.begin', class:'text-no-wrap', sortable: true },
            { text: 'Время', value: 'visit.begin', class:'text-no-wrap', sortable: false },
            { text: 'Услуга', value: 'name', class:'text-no-wrap', sortable: true, width:'300'},
            { text: 'Код в клинике', value: 'isid', class:'text-no-wrap', sortable: true},
            { text: 'Визит', value: 'visit.id', class:'text-no-wrap', sortable: true},
            { text: 'Комментарий', value: 'visit.comment', class:'text-no-wrap', sortable: true, width:'300'},
            { text: 'План лечения', value: 'medPlan.name', class:'text-no-wrap', sortable: true, width:'300'},
            { text: 'Филиал', value: 'visit.comPlace.comRoom.comFloor.comBuilding.comBranch.name', class:'text-no-wrap', sortable: true},
            { text: 'Цена', value: 'price', class:'text-no-wrap', sortable: true },
            { text: 'Количество', value: 'count', class:'text-no-wrap', sortable: true },
            { text: 'Скидка', value: 'discount', class:'text-no-wrap', sortable: true },
            { text: 'Итоговая цена', value: 'priceTotal', class:'text-no-wrap', sortable: false },
            { text: 'Направляющий', value: 'visit.referral.name', class:'text-no-wrap', sortable: true },
            { text: 'Клиент', value: 'visit.user.lastName', class:'text-no-wrap', sortable: true },
            { text: 'Специалист', value: 'visit.userSpec.user.lastName', class:'text-no-wrap', sortable: true },
            { text: 'Создал', value: 'visit.userAuthor.lastName', class:'text-no-wrap', sortable: true },
            { text: 'Организация', value: 'insur.name', class:'text-no-wrap', width: '100%', sortable: true },
            { text: 'Статус оплаты', value: 'payStatus', class:'text-no-wrap', width: '100%', sortable: true },
          ]"
      >
        <template v-slot:item="{item}">
          <tr>
            <td class="text-no-wrap">{{item.id}}</td>
            <td class="text-no-wrap">{{item.service.id}}</td>
            <td class="text-no-wrap">{{$tools.date(item.visit.begin)}}</td>
            <td class="text-no-wrap">{{$tools.time(item.visit.begin)}}</td>
            <td class="text-wrap py-1">
              <tooltip v-if="item.type==='serviceComposite'" right>              
                  <v-icon class="mr-2" size="18" style="margin-top:-1px">mdi-label-multiple-outline</v-icon>
                  <template v-slot:content>
                    Составная услуга
                  </template>
              </tooltip>
              {{item.name}}
              <service-code-view :code="item.code" class="mt-1"/>
            </td>
            <td>
              <div>{{item.isid}}</div>
            </td>
            <td>  
              <v-btn
                @click="visitId=item.visit.id;"
                small
                depressed
              >{{ item.visit.id }}</v-btn>
            </td>
            <td>
              {{item.visit.comment}}
            </td>
            <td class="text-wrap py-1">
              <div v-if="item.medPlan!==null">{{item.medPlan.name}}</div>
              <div v-else class="text-center">-</div>
            </td>
            <td class="text-no-wrap">             
              <div v-if="item.visit.comPlace.comRoom!==null">{{item.visit.comPlace.comRoom.comFloor.comBuilding.comBranch.name}}</div>
              <div v-else class="text-center">-</div>
            </td>
            <td class="text-no-wrap text-right" :data-print="item.price">{{$tools.price(item.price)}}</td>
            <td class="text-no-wrap text-right">{{item.count}}</td>
            <td class="text-no-wrap text-right" :data-print="item.discount">{{$tools.price(item.discount)}}</td>
            <td class="text-no-wrap text-right" :data-print="item.priceTotal">{{$tools.price(item.priceTotal)}}</td>
            <td class="text-no-wrap">
              <span v-if="!item.visit.referral">-</span>
              <UserFullName v-else-if="item.visit.referral.user" :user="item.visit.referral.user"/>
              <span v-else>{{ item.visit.referral.name }}</span>
            </td>
            <td class="text-no-wrap">
              <UserFullName :user="item.visit.user"/>
            </td>
            <td class="text-no-wrap">      
              <UserFullName :user="item.visit.userSpec.user" type="spec"/> 
            </td>
            <td class="text-no-wrap">
              <UserFullName v-if="!!item.visit.userAuthor&&!!item.visit.userAuthor.id" :user="item.visit.userAuthor" type="admin"/> 
            </td>
            <td class="text-no-wrap" v-if="item.insur">
              {{item.insur.name}}
            </td>
            <td class="text-no-wrap text-center" v-else>
              -
            </td>
            <td class="text-no-wrap">
              <status
                  :status="item.payStatus==='wait' ? 'error' : item.payStatus"
                  :text="item.payStatus==='wait' ? 'Не оплачено' : item.payStatus==='success' ? 'Оплачено' : 'Отменено'"
                  :width="100"
              />
            </td>
          </tr>
        </template>
      </n-table-view>
      <visit :visitId.sync="visitId"/>
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import LayoutView from "@/components/LayoutView";
import NTableView from "@/componentsV2/base/NTableView.vue";
import ServiceCodeView from "@/views/Service/ServiceCodeView";
// import LabelView from "@/components/LabelView";
import moment from "moment";
import CardView from "@/components/CardView";
import Status from "@/components/Status";
import InsurSelect from "@/views/Insur/components/InsurSelect";
import ServicesSelect from "@/components/ServicesSelect.vue";
import Visit from "@/views/Visit/Visit";
import ComBranchAutocompleteMultiple from "@/componentsV2/custom/ComBranchAutocompleteMultiple.vue";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import ReferralAutocompleteMultiple from "@/componentsV2/custom/ReferralAutocompleteMultiple.vue";
import SpecAutocompleteMultiple from "@/componentsV2/custom/SpecAutocompleteMultiple.vue";
import DirectionAutocompleteMultiple from "@/componentsV2/custom/DirectionAutocompleteMultiple.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";


import {
  Entity_VisitService, 
  Entity_Insur, 
  Entity_MedPlan, 
  Entity_Service, 
  Entity_Spec, 
  Entity_User, 
  Entity_UserSpec,
  Entity_UserProfile,
  Entity_Visit, 
  Entity_ComPlace,
  Entity_ComRoom,
  Entity_ComFloor,
  Entity_ComBuilding,
  Entity_ComBranch,
  Entity_Direction,
  Entity_Referral
} from "../../../EntityStoreCacheService";

export default {
  components: {
    NTableView, 
    DateInterval,
    ComBranchAutocompleteMultiple,
    InsurSelect,
    Status,
    CardView,
    // UserAutocompleteMultiple,
    // LabelView, 
    ServiceCodeView, 
    LayoutView,
    ServicesSelect,
    Visit,
    TextField,
    AutocompleteMultiple,
    UserAutocompleteMultiple,
    SpecAutocompleteMultiple,
    DirectionAutocompleteMultiple,
    ReferralAutocompleteMultiple,
    CheckboxField,
    Tooltip,
    UserFullName
  },
  data:()=>({
    loadState: new State(),
    filter: {
      dateFrom:moment().format('DD.MM.YYYY'),
      dateTo:moment().format('DD.MM.YYYY'),
      serviceName:null,
      selectedServices: [],
      payStatus:[],
      priceFrom:null,
      priceTo:null,
      userBirthFrom:null,
      userBirthTo:null,
      userGender:[],
      comBranchsSelected:[],
      specsSelected:[],
      categoriesSelected:[],
      directionsSelected:[],
      emptyDirections: false,
      visitServiceId: null,
      visitId: null,
      userClientSelected:[],
      referrerSelected:[],
      userSpecSelected:[],
      userAdminSelected:[],
      insurSelected: [],
      oms: false,
      dms: false
    },
    payStatuses: [
      {name:'Не оплачено',id:'wait'},
      {name:'Оплачено',id:'success'},
    ],
    visitId:null,
    genders: [{name:'Муж.',id:'male'},{name:'Жен.',id:'female'}],
    collectFields: {},
    requestCount: 0,
    responseCount:0
  }),
  watch:{
    filter: {
      deep: true,
      handler () {
        this.$refs.table.load();
      },
    },
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_VisitService()
      .selects(Entity_VisitService.id)
      .selects(Entity_VisitService.isid)
      .selects(Entity_VisitService.name)
      .selects(Entity_VisitService.code)
      .selects(Entity_VisitService.price)
      .selects('priceTotal')
      .selects(Entity_VisitService.count)
      .selects(Entity_VisitService.discount)
      .selects(Entity_VisitService.payStatus)
      .selects(Entity_VisitService.type)
     
      //service
      .selects([Entity_Service.entity, Entity_Service.id].join('.'))

      //medPlan
      .selects([Entity_MedPlan.entity, Entity_MedPlan.name].join('.'))
      
      //visit
      .selects([Entity_Visit.entity, Entity_Visit.id].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.begin].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.comment].join('.'))
      .selects([Entity_Visit.entity,  Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.name].join('.'))


      //user
      .selects([Entity_Visit.entity, Entity_Visit.user, Entity_User.id].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.user, Entity_User.firstName].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.user, Entity_User.lastName].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.user, Entity_User.secondName].join('.'))
      
      //userAuthor
      .selects([Entity_Visit.entity, Entity_Visit.userAuthor, Entity_User.id].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.userAuthor, Entity_User.firstName].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.userAuthor, Entity_User.lastName].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.userAuthor, Entity_User.secondName].join('.'))

      //leadUser
      .selects([Entity_Visit.entity, Entity_Visit.referral, Entity_Referral.id].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.referral, Entity_Referral.name].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.referral, Entity_Referral.user, Entity_User.firstName].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.referral, Entity_Referral.user, Entity_User.lastName].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.referral, Entity_Referral.user, Entity_User.secondName].join('.'))   

      //userSpec
      .selects([Entity_Visit.entity, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.id].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.'))
      .selects([Entity_Visit.entity, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.'))

      //insur
      .selects([Entity_VisitService.insur, Entity_Insur.name].join('.'))

      .collect(Entity_VisitService.collect_indicators)

      rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.status].join('.')+'=?','complete');

      //filter by date
      if(this.filter.dateFrom)  
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.begin].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
      
      if(this.filter.dateTo) 
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.begin].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));
      
      //filter by service name
      if(this.filter.serviceName)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.name].join('.')+' LIKE ?','%'+this.filter.serviceName+'%');

      //filter by service id
      if(this.filter.selectedServices.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.service, Entity_Service.id].join('.')+' in (?)', this.filter.selectedServices.map(i=>i.id));

      //filter by VisitServiceId
      if(this.filter.visitServiceId !== null)
        rb.filterAnd([Entity_VisitService.entity, Entity_Service.id].join('.')+' = ?', this.filter.visitServiceId);
      
      //filter by Visit id
      if(this.filter.visitId !== null)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.id].join('.')+' = ?', this.filter.visitId);     
     
      //filter by price
      if(this.filter.priceFrom)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.price].join('.')+' >=?',parseInt(this.filter.priceFrom));
      
      if(this.filter.priceTo)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.price].join('.')+' <=?',parseInt(this.filter.priceTo));
      
      //filter by pay status
      if(this.filter.payStatus.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.payStatus].join('.')+' in (?)',this.filter.payStatus.map(i=>i.id));
      
      //filter by combranch
      if(this.filter.comBranchsSelected.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id].join('.')+' in (?)',this.filter.comBranchsSelected.map(i=>i.id));

      //filter by directions
      if(this.filter.directionsSelected.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.service, Entity_Service.directions, Entity_Direction.id].join('.')+' in (?)', this.filter.directionsSelected.map(i=>i.id))

      if (this.filter.emptyDirections)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.service, Entity_Service.directions, Entity_Direction.id].join('.')+' is null');
      
      //filter by insur
      if(this.filter.insurSelected.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.insur, Entity_Insur.id].join('.')+' in (?)', this.filter.insurSelected.map(i=>i.id))
      
      let insurMode = [];
      if (this.filter.oms) insurMode.push('oms');
      if (this.filter.dms) insurMode.push('dms');
      insurMode = insurMode.length ? insurMode : null;
     
      if(insurMode)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.mode].join('.')+' in  (?)', insurMode)
  
      
      //filter by spec + specComposite
      if(this.filter.specsSelected.length>0) {
        let specSelected = this.filter.specsSelected.map(i=>i.id)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.')+' in (?) OR ' + [Entity_VisitService.entity, Entity_VisitService.visitServiceComposites, Entity_VisitService.specComposite, Entity_Spec.id].join('.')+' in (?)',specSelected,specSelected)
      }

      //filter by userSpec + userComposite
      if (this.filter.userSpecSelected.length>0)
        rb.filterAdd('userSpecsIds', this.filter.userSpecSelected.map(i=>i.id).join(','));
      
      //filter by client
      if (this.filter.userClientSelected.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.user,Entity_User.id].join('.')+' in (?)',this.filter.userClientSelected.map(i=>i.id))
      
       
      if (this.filter.userAdminSelected.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.userAuthor, Entity_User.id].join('.')+' in (?)',this.filter.userAdminSelected.map(i=>i.id))
      
      if (this.filter.userGender.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.user,Entity_User.userProfile, Entity_UserProfile.gender].join('.')+' in (?)',this.filter.userGender.map(i=>i.id))
      

      //filter by referrer
      if (this.filter.referrerSelected.length>0)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.referral, Entity_Referral.id].join('.')+' in (?)',this.filter.referrerSelected.map(i=>i.id))
      
      //filter by birth date
      if(this.filter.userBirthFrom)
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.user,Entity_User.userProfile, Entity_UserProfile.birth].join('.')+'>=?',moment(this.filter.userBirthFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));

      if(this.filter.userBirthTo)  
        rb.filterAnd([Entity_VisitService.entity, Entity_VisitService.visit, Entity_Visit.user,Entity_User.userProfile, Entity_UserProfile.birth].join('.')+'<=?',moment(this.filter.userBirthTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));

      
      rb.page(page).onPage(onPage)

      rb.addStateCallback((v)=>{
        if (v.success)
            this.responseCount++

        if (this.responseCount!==this.requestCount) {
          v.loading = true
          v.success = false
        }
        
        this.loadState.setRequestBuilderState(v)  
        
        if(this.loadState.isSuccess)
          this.collectFields = v.collect.indicators;

      })

      sortFields.forEach(v=>{
        console.log(v)
        rb.order(v.field, v.isAsc)
      })

      this.requestCount++
      return rb;
    }
  }
}
</script>
